/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramGeoControllerGetRegionsQueryResponse,
  TelegramGeoControllerGetRegionsPathParams,
} from '../types/TelegramGeoControllerGetRegions.ts';

function getTelegramGeoGetRegionsUrl(countryId: TelegramGeoControllerGetRegionsPathParams['countryId']) {
  const res = { method: 'GET', url: `/api/telegram/geo/regions/${countryId}` as const };
  return res;
}

/**
 * {@link /api/telegram/geo/regions/:countryId}
 */
export async function telegramGeoGetRegions(
  countryId: TelegramGeoControllerGetRegionsPathParams['countryId'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<TelegramGeoControllerGetRegionsQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getTelegramGeoGetRegionsUrl(countryId).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
